import Events from 'HSNDIR/Events.js';

HSN.ConfigLoader = function(config) {
    this.application = config.application;
    var scope = this;

    $.ajax({
        url: '/api/configuration',
        beforeSend: function (xhr) {
            xhr.setRequestHeader('X-Requested-With', { toString: function () { return ''; } });
        }
    }).done(function (data) {
        HSN.Config = data;
        scope.application.Events.Trigger(Events.Config.LOADED, data);
    });
};


// WEBPACK FOOTER //
// ./assets/js/HSN/Config.js